<template>
  <div class="">
    <div
      v-if="!disableAltText"
      class="row"
    >
      <div class="col text-capitalize">
        {{ $t("element.property.image.alt.label") }}
      </div>
      <div class="col-12">
        <cvt-input
          v-model="alt"
          type="text"
          :placeholder="$t('element.property.image.alt.alt_message')"
        />
      </div>
    </div>

    <div
      v-if="!disableAltText"
      class="divider"
    />

    <div class="row">
      <div
        v-if="OrgName !== orgNameFreshWork"
        class="col text-capitalize"
      >
        {{ $t("element.property.link") }}
      </div>
      <div v-else class="col align-items-center">
        <h6 :class="textColorClass" >Hyperlink image</h6>
      </div>
      <div class="col-12">
        <url-input
          v-model="href"
          type="text"
          :placeholder="$t('element.property.image.alt.link_message')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import * as getters from '../../../store/modules/getters'
import * as actions from '../../../store/modules/actions'
import * as mutations from '../../../store/modules/mutations'
import { LEFT_SIDEBAR_FRESHWORKS, LEFT_SIDEBAR_STANDARD } from '../../../../../../storybook/components/constants'
export default {
  props: {
    disableAltText: Boolean
  },
  data() {
    return {
      orgNameFreshWork: LEFT_SIDEBAR_FRESHWORKS
    }
  },
  computed: {
    ...mapGetters({
      selected: getters.SELECTOR_SELECTED
    }),
    ...mapState('globalTheme', {
      OrgName: ({ globalTheme }) => globalTheme.OrgName !== undefined ? globalTheme.OrgName : LEFT_SIDEBAR_STANDARD
    }),
    textColorClass () {
      return {'text-white': this.mode=='DARK'}
    },
    href: {
      get () {
        return this.selected?.href || '';
      },

      set: _.debounce(function (value) {
        return this.updateProp({
          key: 'href',
          value
        })
      }, 1000)
    },
    alt: {
      get () {
        return this.selected?.alt || '';
      },

      set: _.debounce(function ({ target }) {
        return this.updateProp({
          key: 'alt',
          value: target.value
        })
      }, 1000)
    }
  },
  methods: {
    ...mapActions({
      updateProp: actions.SELECTOR_UPDATE_PROP
    })
  }
}
</script>

<style lang="css">
</style>
